
export enum LanguageEnum {
    ALL = 1,
    ENGLISH = 2,
    FRENCH = 3
}
